module.exports = __webpack_public_path__ + "img/background_16.187c8dd3.jpg";